var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: 'https://auth.alo-gaz.com/',
  baseApiUrl: 'https://auth.alo-gaz.com/api/',
  orderStatus: {
    INITIATED: 0,
    CONFIRMED_PAID: 1,
    ASSIGNED: 2,
    ON_THE_WAY: 3,
    DELIVERED: 4,
    CANCELLED: 5
  },
  userRoles: {
    ADMIN: 99,
    POS_MANAGER: 70,
    DRIVER: 60
  },
  Regions: ['Kaloum', 'Dixinn', 'Ratoma', 'Matam', 'Matoto', 'Beyla', 'Boffa', 'Boké', 'Coyah', 'Dabola', 'Dalaba', 'Dinguiraye', 'Dubréka', 'Faranah', 'Forécariah', 'Fria', 'Gaoual', 'Guéckédou', 'Kankan', 'Kérouané', 'Kindia', 'Kissidougou', 'Koubia', 'Koundara', 'Kouroussa', 'Labé', 'Lélouma', 'Lola', 'Macenta', 'Mamou', 'Mandiana', 'Nzérékoré', 'Pita', 'Siguiri', 'Télimélé', 'Tougué', 'Yomou']
};
export default Common;